import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import health1 from '../Images/health1.png';
import health2 from '../Images/health2.jpg';
import health3 from '../Images/health3.jpg';

import '../Cardpage.css'
function Health() {
  return (
    <>
    <Carousel fade style={{zIndex:'-1'}}  className='text-black'>
      <Carousel.Item>
        <img className='w-100' src={health2} alt="" />
      </Carousel.Item>
      <Carousel.Item>
      <img src={health1} className='w-100' alt="" />
      </Carousel.Item>
      <Carousel.Item>
      <img src={health3} className='w-100' alt="" />
      </Carousel.Item>
    </Carousel>

    <div className='mt-5 mb-5' style={{textAlign:'center'}}>
        <h2 className='healthhead'>Your Health, Our Priority: Wellness Starts Here</h2>
            <div className='ms-2 mb-4 me-2 healthsect'>
                We aims to maintain a good health for our customers. That's why we have started this new section. We have most of the healthy products in our stock in the least price.
                This section contain all body health maintain products that helps you to maintain your body health in a low cost way. Try it and be health pros...
                <div className='text-center'>
                <p style={{color:'crimson'}}>RUNNING ON SPECIAL DISCOUNT</p>
                </div>
            </div>
            <div>
              <iframe className='ms-3 me-3 rounded video1'  src="https://www.youtube.com/embed/XMcab1MFaLc?si=lq9jaN9wNzrHE2eU&autoplay=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div className='ms-4' style={{fontFamily:'times new roman'}}>
              <h4 className='mt-5'>Major health products:</h4>
              <div>
                <div className='d-flex'>
                <div>
                <ul className='d-flex flex-wrap '>
                  <li className='me-4'>Berry Mix</li>
                  <li className='me-4'>Oats Muesli</li>
                  <li className='me-4'>Dates Bites</li>
                  <li className='me-4'>Coconut Oats</li>
                  <li className='me-4'>High Protein Mixture</li>
                  <li className='me-4'>Flax Seed Laddu</li>
                  <li className='me-4'>Multigrains Cookies</li>
                  <li className='me-4'>Black Berries</li>
                  <li className='me-4'>Seed Mix</li>
                  <li className='me-4'>Sport Mix</li>
                  <li className='me-4'>Date Nuts Bar</li>
                  <li className='me-4'>Dried Fruit</li>
                  <li className='me-4'>Lotus Seed Fried</li>
                  <li className='me-4'>Olive Oil</li>
                  <li className='me-4'>Dry Fruits and Nuts</li>
                  <li className='me-4'>Chia Seed</li>
                  <li className='me-4'>Fruit and Nuts Muesli</li>
                  <li className='me-4'>Peanut Butter</li>
                  <li className='me-4'>Daily Green Capsules</li>
                  <li className='me-4'>Spinach Powder</li>
                  <li className='me-4'>Beetroot Powder</li>
                  <li className='me-4'>Health Mix</li>
                  <li className='me-4'>Sugar free Jam</li>
                  <li className='me-4'>Green Tea</li>
                  <li className='me-4'>Berry Crunch</li>
                  <li className='me-4'>Sugar-free pure Jam</li>
                  <li className='me-4'>Almond Oil</li>
                  <li className='me-4'>Pure Honey</li>
                  <li className='me-4'>Date Syrup</li>
                </ul>
              </div>
                </div>
                <div>

                </div>
              </div>
            </div>
    </div>
    </>
  )
}

export default Health